import React, {useEffect} from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import AlertTitle from '@mui/material/AlertTitle';
import emailMImg from '../../assets/img/email_m.jpg';

import useScrollTop from '../../hooks/useScrollTop';
import {useDataProviderState} from '../../providers/DataProvider';
import {TrackGoogleAnalyticsEvent} from "../../google-analytics/gaTracker.js";

export default function FinalStep() {

    const {userData} = useDataProviderState();

    useScrollTop();

    TrackGoogleAnalyticsEvent("FinalStep");

    return (
        <Container component="section" sx={{p: 0, m: 0}}>

            <Grid container spacing={{xs: 0, sm: 2, pb: 0}} alignItems="center" justifyContent="center">
                <Grid item sm={10} xs={12} sx={{pb: 0}}>
                    <Box sx={{display: 'flex', justifyContent: 'center', py: 0, mb: 2}}>
                        <Box sx={{alignItems: 'center'}}>
                            <Link
                                href="https://www.valor.com.uy"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={emailMImg}
                                    className="img-fluid"
                                />
                            </Link>
                        </Box>
                    </Box>
                </Grid>

                <Grid item sm={10} xs={12} sx={{pb: 0}}>
                    <Box>
                        {/*<p>Estimado {userData.nombre},</p>*/}
                        {/*<p>Muchas gracias por confiar en nosotros!</p>*/}
                        {/*<p>Tu solicitud fue pre-aprobada, nos estaremos comunicando contigo a la brevedad al*/}
                        {/*    celular que nos proporcionaste.</p>*/}
                        {/*<p>Cualquier consulta no dudes en comunicarte con nosotros, nos podes llamar al 24870083*/}
                        {/*    o enviarnos un whatsapp al 095 896 000.</p>*/}
                        {/*<p>Que tengas un lindo día.</p>*/}
                        <Box as="h2" className="color-primary" display="flex" alignItems="center" justifyContent="center" sx={{m: 0}}>
                            ¡Felicitaciones {userData.nombre},
                        </Box>
                        <Box as="h3" display="flex" alignItems="center" justifyContent="center" sx={{m: 0}}>
                            ¡Tu préstamo está en camino!
                        </Box>
                        <p>En la siguiente hora, vas a recibir un SMS en el celular que nos proporcionaste, confirmando cuando podrás retirar el dinero.</p>
                        <p>Luego deberás dirigirte a un local de Abitab o Red Pagos con tu cédula de identidad y solicitar el servicio: CREDITO DE VALOR – DESEMBOLSO CON DOC. Ahí mismo, deberás firmar la documentación.</p>
                        <p>¡Esperamos que disfrutes tu préstamo y agradecemos tu confianza en Crédito de Valor!</p>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    )
}
